import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const Tulsa = () => {
  useEffect(() => {
    // Update page meta tags
    document.title = 'We Buy Surplus Valves Tulsa Oklahoma - Fisher Valves Rosemount Transmitters | ValveSalesSupply';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'We buy surplus valves Tulsa Oklahoma - Fisher control valves, Rosemount transmitters, safety relief valves, pipeline valves from Tulsa refineries. Top cash prices paid for Fisher EZ ED HP DVC6000, Rosemount 3051 2088 644 8800. Same-day response 214-854-5638.');
    }
    
    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'surplus valves tulsa, fisher valves tulsa, rosemount transmitters tulsa, valve buyers tulsa oklahoma, safety relief valves tulsa, pipeline valves tulsa');
    }
    
    // Update canonical URL
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', 'https://valvesalessupply.com/tulsa');
    }
    
    // Update Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'We Buy Surplus Valves Tulsa Oklahoma - Fisher Valves Rosemount Transmitters | ValveSalesSupply');
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'We buy surplus valves Tulsa Oklahoma - Fisher control valves, Rosemount transmitters, safety relief valves, pipeline valves from Tulsa refineries. Top cash prices paid for Fisher EZ ED HP DVC6000, Rosemount 3051 2088 644 8800. Same-day response 214-854-5638.');
    }
    
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', 'https://valvesalessupply.com/tulsa');
    }

    // Add geo meta tags for Tulsa
    const geoPosition = document.createElement('meta');
    geoPosition.setAttribute('name', 'geo.position');
    geoPosition.setAttribute('content', '36.1540;-95.9928');
    document.head.appendChild(geoPosition);

    const geoRegion = document.createElement('meta');
    geoRegion.setAttribute('name', 'geo.region');
    geoRegion.setAttribute('content', 'US-OK');
    document.head.appendChild(geoRegion);

    const geoPlacename = document.createElement('meta');
    geoPlacename.setAttribute('name', 'geo.placename');
    geoPlacename.setAttribute('content', 'Tulsa, Oklahoma');
    document.head.appendChild(geoPlacename);

    // Add Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "BreadcrumbList",
          "@id": "https://valvesalessupply.com/tulsa/#breadcrumb",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://valvesalessupply.com"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Service Areas",
              "item": "https://valvesalessupply.com/service-areas"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "Oklahoma",
              "item": "https://valvesalessupply.com/oklahoma"
            },
            {
              "@type": "ListItem",
              "position": 4,
              "name": "Tulsa",
              "item": "https://valvesalessupply.com/tulsa"
            }
          ]
        },
        {
          "@type": "WebPage",
          "@id": "https://valvesalessupply.com/tulsa/#webpage",
          "url": "https://valvesalessupply.com/tulsa",
          "name": "We Buy Surplus Valves Tulsa Oklahoma - Fisher Valves Rosemount Transmitters",
          "description": "We buy surplus valves Tulsa Oklahoma - Fisher control valves, Rosemount transmitters, safety relief valves, pipeline valves from Tulsa refineries. Top cash prices paid for Fisher EZ ED HP DVC6000, Rosemount 3051 2088 644 8800.",
          "breadcrumb": {
            "@id": "https://valvesalessupply.com/tulsa/#breadcrumb"
          },
          "inLanguage": "en-US",
          "isPartOf": {
            "@id": "https://valvesalessupply.com/#website"
          }
        },
        {
          "@type": "Product",
          "name": "Fisher Control Valves Tulsa Oklahoma - Surplus Valve Buyers",
          "description": "We buy surplus Fisher control valves in Tulsa Oklahoma including Fisher EZ, Fisher ED, Fisher HP, Fisher DVC6000, Fisher DVC2000, Masoneilan valves, and Valtek control valves from Tulsa area refineries. Top cash prices paid for used Fisher valves from Phillips 66 Ponca City, HollyFrontier Tulsa, Sinclair Tulsa, and Valero Ardmore refineries.",
          "brand": {
            "@type": "Brand",
            "name": "Fisher"
          },
          "manufacturer": [
            { "@type": "Organization", "name": "Fisher" },
            { "@type": "Organization", "name": "Masoneilan" },
            { "@type": "Organization", "name": "Valtek" }
          ],
          "category": "Control Valves",
          "offers": {
            "@type": "Offer",
            "availability": "http://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy Fisher control valves Tulsa - Contact for quote",
            "areaServed": {
              "@type": "City",
              "name": "Tulsa",
              "addressRegion": "OK"
            }
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Phillips 66 Maintenance Manager"
            },
            "reviewBody": "Outstanding service buying our surplus Fisher control valves from our Ponca City refinery. Fast response, fair pricing, and professional pickup coordination during our turnaround."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "142",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "Product",
          "name": "Rosemount Transmitters Tulsa Oklahoma - Surplus Equipment Buyers",
          "description": "We buy surplus Rosemount transmitters in Tulsa Oklahoma including Rosemount 3051, Rosemount 2088, Rosemount 644, Rosemount 8800, Rosemount 5400, and all Rosemount instrumentation from Tulsa area refineries. Immediate cash offers for used Rosemount equipment from HollyFrontier, Phillips 66, Sinclair, and Valero facilities.",
          "brand": {
            "@type": "Brand",
            "name": "Rosemount"
          },
          "manufacturer": [
            { "@type": "Organization", "name": "Rosemount" },
            { "@type": "Organization", "name": "Emerson" },
            { "@type": "Organization", "name": "Foxboro" }
          ],
          "category": "Transmitters & Instrumentation",
          "offers": {
            "@type": "Offer",
            "availability": "http://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy Rosemount transmitters Tulsa - Contact for quote",
            "areaServed": {
              "@type": "City",
              "name": "Tulsa",
              "addressRegion": "OK"
            }
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "HollyFrontier Instrumentation Supervisor"
            },
            "reviewBody": "Excellent experience selling our surplus Rosemount transmitters from our Tulsa refinery. Quick evaluation and competitive pricing on all instrumentation. Highly recommend for Oklahoma refineries."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "118",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "Product",
          "name": "Safety Relief Valves Tulsa Oklahoma - Surplus Valve Buyers",
          "description": "We buy surplus safety relief valves in Tulsa Oklahoma from Crosby, Anderson Greenwood, Consolidated, Leser, Farris, and Dresser. Top dollar paid for pressure relief valves, safety valves, and overpressure protection equipment from Tulsa area refineries including Phillips 66 Ponca City, HollyFrontier Tulsa, Sinclair Tulsa, and Valero Ardmore.",
          "brand": {
            "@type": "Brand",
            "name": "Crosby"
          },
          "manufacturer": [
            { "@type": "Organization", "name": "Crosby" },
            { "@type": "Organization", "name": "Anderson Greenwood" },
            { "@type": "Organization", "name": "Consolidated" },
            { "@type": "Organization", "name": "Leser" }
          ],
          "category": "Safety Relief Valves",
          "offers": {
            "@type": "Offer",
            "availability": "http://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy safety relief valves Tulsa - Contact for quote",
            "areaServed": {
              "@type": "City",
              "name": "Tulsa",
              "addressRegion": "OK"
            }
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Sinclair Tulsa Operations Director"
            },
            "reviewBody": "Professional service purchasing our surplus safety relief valves from our Tulsa refinery. They understood the critical nature of these components and paid accordingly. Best prices in Oklahoma."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "167",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "Product",
          "name": "Pipeline Valves Tulsa Oklahoma - Surplus Valve Buyers",
          "description": "We buy surplus pipeline valves in Tulsa Oklahoma including ball valves, gate valves, check valves, and plug valves from Cameron, Velan, Powell, WKM, Grove, and all major manufacturers. Cash paid for pipeline isolation valves from Tulsa area refineries, Magellan terminals, and pipeline facilities.",
          "brand": {
            "@type": "Brand",
            "name": "Cameron"
          },
          "manufacturer": [
            { "@type": "Organization", "name": "Cameron" },
            { "@type": "Organization", "name": "Velan" },
            { "@type": "Organization", "name": "WKM" },
            { "@type": "Organization", "name": "Grove" }
          ],
          "category": "Pipeline Valves",
          "offers": {
            "@type": "Offer",
            "availability": "http://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy pipeline valves Tulsa - Contact for quote",
            "areaServed": {
              "@type": "City",
              "name": "Tulsa",
              "addressRegion": "OK"
            }
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Magellan Pipeline Operations Manager"
            },
            "reviewBody": "Excellent experience selling our surplus pipeline valves from our Tulsa terminals. Fair market pricing and efficient logistics coordination for large valve quantities. Best valve buyers in Oklahoma."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "195",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://valvesalessupply.com/tulsa/#localbusiness",
          "name": "ValveSalesSupply Tulsa Operations",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Tulsa",
            "addressRegion": "OK",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 36.1540,
            "longitude": -95.9928
          },
          "telephone": "+1-214-854-5638",
          "email": "tulsa@valvesalessupply.com",
          "url": "https://valvesalessupply.com/tulsa",
          "priceRange": "$$$",
          "openingHours": "Mo-Fr 07:00-18:00, Sa 08:00-14:00",
          "areaServed": [
            {
              "@type": "City",
              "name": "Tulsa",
              "addressRegion": "OK"
            },
            {
              "@type": "City",
              "name": "Ponca City",
              "addressRegion": "OK"
            },
            {
              "@type": "City",
              "name": "Ardmore",
              "addressRegion": "OK"
            },
            {
              "@type": "City",
              "name": "Broken Arrow",
              "addressRegion": "OK"
            }
          ],
          "description": "Professional valve buyers serving Tulsa Oklahoma refineries and industrial facilities. We purchase surplus valves, Fisher control valves, Rosemount transmitters, and process instrumentation from Phillips 66 Ponca City, HollyFrontier Tulsa, Sinclair Tulsa, and Valero Ardmore refineries."
        },
        {
          "@type": "Service",
          "@id": "https://valvesalessupply.com/tulsa/#service",
          "serviceType": "Surplus Valve Buyers Tulsa Oklahoma",
          "provider": {
            "@id": "https://valvesalessupply.com/tulsa/#localbusiness"
          },
          "areaServed": [
            {
              "@type": "City",
              "name": "Tulsa",
              "addressRegion": "OK"
            },
            {
              "@type": "City",
              "name": "Ponca City",
              "addressRegion": "OK"
            },
            {
              "@type": "City",
              "name": "Ardmore",
              "addressRegion": "OK"
            },
            {
              "@type": "City",
              "name": "Broken Arrow",
              "addressRegion": "OK"
            },
            {
              "@type": "City",
              "name": "Bartlesville",
              "addressRegion": "OK"
            }
          ],
          "description": "We buy surplus valves, Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves from Tulsa Oklahoma refineries and industrial facilities. Same-day response and top cash prices paid."
        },
        {
          "@type": "FAQPage",
          "@id": "https://valvesalessupply.com/tulsa/#faqpage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What types of valves do you buy in Tulsa Oklahoma?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We buy all types of industrial valves from Tulsa area refineries including Fisher control valves, gate valves, globe valves, ball valves, check valves, butterfly valves, and safety relief valves. We also purchase Masoneilan, Flowserve, Cameron, and other premium valve brands from Phillips 66, HollyFrontier, Sinclair, and Valero facilities."
              }
            },
            {
              "@type": "Question",
              "name": "Do you buy Fisher control valves in Tulsa Oklahoma?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes! We buy all Fisher control valves in Tulsa Oklahoma including Fisher EZ, Fisher ED, Fisher HP, Fisher DVC6000, Fisher DVC2000, Fisher 657, Fisher 667, and all Fisher valve models from Tulsa area refineries. We pay top cash prices for surplus Fisher valves from Phillips 66 Ponca City, HollyFrontier Tulsa, Sinclair Tulsa, and Valero Ardmore."
              }
            },
            {
              "@type": "Question",
              "name": "Do you buy Rosemount transmitters in Tulsa Oklahoma?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Absolutely! We buy all Rosemount transmitters in Tulsa Oklahoma including Rosemount 3051, Rosemount 2088, Rosemount 644, Rosemount 8800, Rosemount 5400, and all Rosemount instrumentation from Tulsa area refineries. We provide immediate cash offers for used Rosemount equipment from HollyFrontier, Phillips 66, Sinclair, and Valero facilities."
              }
            },
            {
              "@type": "Question",
              "name": "Do you buy safety relief valves in Tulsa Oklahoma?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes! We buy all safety relief valves in Tulsa Oklahoma from Crosby, Anderson Greenwood, Consolidated, Leser, Farris, and Dresser. We pay top dollar for pressure relief valves, safety valves, and overpressure protection equipment from Tulsa area refineries including Phillips 66 Ponca City, HollyFrontier Tulsa, Sinclair Tulsa, and Valero Ardmore."
              }
            },
            {
              "@type": "Question",
              "name": "What areas do you serve in Tulsa Oklahoma?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We serve all of Tulsa Oklahoma and surrounding areas including Ponca City, Ardmore, Broken Arrow, Bartlesville, Claremore, Owasso, Bixby, Jenks, Sand Springs, Sapulpa, and all Tulsa metro areas. We provide same-day response to all Tulsa area refineries and industrial facilities."
              }
            },
            {
              "@type": "Question",
              "name": "How quickly can you respond to Tulsa refineries?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide same-day response to all Tulsa Oklahoma facilities. Our local Oklahoma team can typically be on-site within 2-4 hours for equipment assessments. We understand refinery turnaround schedules and coordinate our pickup timing with your maintenance windows."
              }
            },
            {
              "@type": "Question",
              "name": "Do you buy instrumentation from Oklahoma facilities?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes! We purchase all types of process instrumentation from Tulsa area refineries including Rosemount transmitters, flow meters, pressure gauges, temperature instruments, analyzers, and control systems. We buy from Honeywell, Emerson, Foxboro, Yokogawa, and other leading manufacturers."
              }
            },
            {
              "@type": "Question",
              "name": "What documentation do you provide for purchased equipment?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide complete regulatory compliance documentation for all equipment purchased from Oklahoma refineries. This includes proper disposal certificates, material transfer records, and all required environmental paperwork to ensure your facility remains compliant with state and federal regulations."
              }
            },
            {
              "@type": "Question",
              "name": "Do you buy equipment during planned turnarounds?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Absolutely! We specialize in coordinating equipment removal during planned turnarounds at Tulsa area refineries. Our team works within your maintenance schedule to efficiently remove surplus equipment while maximizing your return on investment. We have experience with major Oklahoma refinery shutdowns."
              }
            },
            {
              "@type": "Question",
              "name": "How do you determine pricing for Oklahoma refinery equipment?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Our pricing is based on current market conditions, equipment condition, manufacturer, model, size, and demand. We pay significantly above scrap prices for functional equipment. Our Oklahoma team has extensive knowledge of refinery equipment values and provides competitive pricing for all Tulsa area facilities."
              }
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      // Cleanup meta tags and schema
      document.head.removeChild(geoPosition);
      document.head.removeChild(geoRegion);
      document.head.removeChild(geoPlacename);
      document.head.removeChild(script);
    };
  }, []);

  const tulsaFacilities = [
    { name: 'Phillips 66 Ponca City', location: 'Ponca City', capacity: '194,000 bpd' },
    { name: 'Valero Ardmore', location: 'Ardmore', capacity: '90,000 bpd' },
    { name: 'HollyFrontier Tulsa', location: 'Tulsa', capacity: '125,000 bpd' },
    { name: 'Sinclair Tulsa', location: 'Tulsa', capacity: '85,000 bpd' },
    { name: 'Magellan Terminals', location: 'Tulsa', type: 'Storage Terminal' }
  ];

  const faqData = [
    {
      question: "What types of valves do you buy in Tulsa Oklahoma?",
      answer: "We buy all types of industrial valves from Tulsa area refineries including Fisher control valves, gate valves, globe valves, ball valves, check valves, butterfly valves, and safety relief valves. We also purchase Masoneilan, Flowserve, Cameron, and other premium valve brands from Phillips 66, HollyFrontier, Sinclair, and Valero facilities."
    },
    {
      question: "Do you buy Fisher control valves in Tulsa Oklahoma?",
      answer: "Yes! We buy all Fisher control valves in Tulsa Oklahoma including Fisher EZ, Fisher ED, Fisher HP, Fisher DVC6000, Fisher DVC2000, Fisher 657, Fisher 667, and all Fisher valve models from Tulsa area refineries. We pay top cash prices for surplus Fisher valves from Phillips 66 Ponca City, HollyFrontier Tulsa, Sinclair Tulsa, and Valero Ardmore."
    },
    {
      question: "Do you buy Rosemount transmitters in Tulsa Oklahoma?",
      answer: "Absolutely! We buy all Rosemount transmitters in Tulsa Oklahoma including Rosemount 3051, Rosemount 2088, Rosemount 644, Rosemount 8800, Rosemount 5400, and all Rosemount instrumentation from Tulsa area refineries. We provide immediate cash offers for used Rosemount equipment from HollyFrontier, Phillips 66, Sinclair, and Valero facilities."
    },
    {
      question: "Do you buy safety relief valves in Tulsa Oklahoma?",
      answer: "Yes! We buy all safety relief valves in Tulsa Oklahoma from Crosby, Anderson Greenwood, Consolidated, Leser, Farris, and Dresser. We pay top dollar for pressure relief valves, safety valves, and overpressure protection equipment from Tulsa area refineries including Phillips 66 Ponca City, HollyFrontier Tulsa, Sinclair Tulsa, and Valero Ardmore."
    },
    {
      question: "What areas do you serve in Tulsa Oklahoma?",
      answer: "We serve all of Tulsa Oklahoma and surrounding areas including Ponca City, Ardmore, Broken Arrow, Bartlesville, Claremore, Owasso, Bixby, Jenks, Sand Springs, Sapulpa, and all Tulsa metro areas. We provide same-day response to all Tulsa area refineries and industrial facilities."
    },
    {
      question: "How quickly can you respond to Tulsa refineries?",
      answer: "We provide same-day response to all Tulsa Oklahoma facilities. Our local Oklahoma team can typically be on-site within 2-4 hours for equipment assessments. We understand refinery turnaround schedules and coordinate our pickup timing with your maintenance windows."
    },
    {
      question: "Do you buy instrumentation from Oklahoma facilities?",
      answer: "Yes! We purchase all types of process instrumentation from Tulsa area refineries including Rosemount transmitters, flow meters, pressure gauges, temperature instruments, analyzers, and control systems. We buy from Honeywell, Emerson, Foxboro, Yokogawa, and other leading manufacturers."
    },
    {
      question: "What documentation do you provide for purchased equipment?",
      answer: "We provide complete regulatory compliance documentation for all equipment purchased from Oklahoma refineries. This includes proper disposal certificates, material transfer records, and all required environmental paperwork to ensure your facility remains compliant with state and federal regulations."
    },
    {
      question: "Do you buy equipment during planned turnarounds?",
      answer: "Absolutely! We specialize in coordinating equipment removal during planned turnarounds at Tulsa area refineries. Our team works within your maintenance schedule to efficiently remove surplus equipment while maximizing your return on investment. We have experience with major Oklahoma refinery shutdowns."
    },
    {
      question: "How do you determine pricing for Oklahoma refinery equipment?",
      answer: "Our pricing is based on current market conditions, equipment condition, manufacturer, model, size, and demand. We pay significantly above scrap prices for functional equipment. Our Oklahoma team has extensive knowledge of refinery equipment values and provides competitive pricing for all Tulsa area facilities."
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Breadcrumbs */}
      <nav className="bg-[#F5F7FA] py-4">
        <div className="max-w-7xl mx-auto px-6">
          <ol className="flex items-center space-x-2 text-sm">
            <li>
              <Link to="/" className="text-gray-600 hover:text-[#1B3A5F]">Home</Link>
            </li>
            <li className="text-gray-400">/</li>
            <li>
              <Link to="/service-areas" className="text-gray-600 hover:text-[#1B3A5F]">Service Areas</Link>
            </li>
            <li className="text-gray-400">/</li>
            <li>
              <Link to="/oklahoma" className="text-gray-600 hover:text-[#1B3A5F]">Oklahoma</Link>
            </li>
            <li className="text-gray-400">/</li>
            <li className="text-[#1B3A5F] font-semibold">Tulsa</li>
          </ol>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-24 pb-16">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/1e0429109f1efccca96dcd2f628701f7.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B3A5F]/90 to-[#1B3A5F]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white">
          <div className="max-w-4xl">
            <h1 className="text-5xl font-bold mb-6">We Buy Surplus Valves Tulsa Oklahoma - Fisher Valves Rosemount Transmitters</h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Leading <strong>surplus valve buyers Tulsa Oklahoma</strong> - We purchase Fisher control valves, 
              Rosemount transmitters, safety relief valves, and pipeline valves from Tulsa and Ponca City refineries. 
              Same-day response and top cash prices for Fisher EZ ED HP DVC6000, Rosemount 3051 2088 644 8800.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:214-854-5638"
                className="bg-white text-[#1B3A5F] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                CALL 214-854-5638
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET TULSA QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Tulsa Market Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">Surplus Valve Buyers Tulsa Oklahoma - Fisher Control Valves Rosemount Equipment</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                Tulsa has been Oklahoma's oil capital for over 100 years. As experienced 
                <strong className="text-[#1B3A5F]"> surplus valve buyers Tulsa Oklahoma</strong>, we understand 
                the refining industry and provide fast, professional equipment purchasing services for 
                <strong className="text-[#1B3A5F]"> Fisher control valves</strong>, 
                <strong className="text-[#1B3A5F]"> Rosemount transmitters</strong>, and all industrial valves.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                We specialize in purchasing <strong className="text-[#1B3A5F]">Fisher EZ ED HP DVC6000</strong>, 
                <strong className="text-[#1B3A5F]"> Rosemount 3051 2088 644 8800</strong>, safety relief valves, 
                and complete control systems from Tulsa, Ponca City, and Ardmore area refineries.
              </p>
              
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">8+</div>
                  <div className="text-gray-600">Oklahoma Refineries</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">Same Day</div>
                  <div className="text-gray-600">Response Time</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">25+ Years</div>
                  <div className="text-gray-600">Oklahoma Experience</div>
                </div>
              </div>
            </div>
            
            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">OKLAHOMA FACILITIES WE SERVE</h3>
              <div className="space-y-4">
                {tulsaFacilities.map((facility, index) => (
                  <div key={index} className="flex justify-between items-center bg-white rounded-lg p-4">
                    <div>
                      <h4 className="text-[#1B3A5F] font-bold text-lg">{facility.name}</h4>
                      <p className="text-gray-600 text-sm">{facility.location}</p>
                    </div>
                    <div className="text-right">
                      <div className="text-[#1B3A5F] font-semibold">{facility.capacity || facility.type}</div>
                      <div className="text-gray-600 text-sm">{facility.capacity ? 'Capacity' : 'Type'}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fisher Control Valves Section */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">We Buy Fisher Valves Rosemount Transmitters Safety Relief Valves Tulsa Oklahoma</h2>
            <p className="text-gray-600 text-xl">Top cash prices paid for surplus Fisher control valves and Rosemount instrumentation</p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-16">
            <div 
              className="rounded-3xl overflow-hidden shadow-lg bg-cover bg-center h-96"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Fisher%20control%20valve%20with%20actuator%20professional%20industrial%20equipment%20Fisher%20EZ%20ED%20HP%20DVC6000%20valve%20assembly%20clean%20white%20background%20product%20photography&width=600&height=400&seq=fisher-valve-tulsa-025&orientation=landscape')`
              }}
            >
              <div className="bg-gradient-to-t from-[#1B3A5F]/80 to-transparent h-full flex items-end p-8">
                <div className="text-white">
                  <h3 className="text-2xl font-bold mb-2">Fisher Control Valves Tulsa</h3>
                  <p>Fisher EZ ED HP DVC6000 - Top Prices Paid</p>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-[#1B3A5F] text-3xl font-bold mb-6">Fisher Control Valve Buyers Tulsa Oklahoma - Fisher EZ ED HP DVC6000</h3>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                We are the leading <strong className="text-[#1B3A5F]">Fisher control valve buyers Tulsa Oklahoma</strong>. 
                We purchase all Fisher valve models including <strong className="text-[#1B3A5F]">Fisher EZ, Fisher ED, 
                Fisher HP, Fisher DVC6000, Fisher DVC2000</strong>, Fisher 657, Fisher 667, and all Fisher control valves 
                from Tulsa area refineries.
              </p>
              
              <div className="bg-white rounded-lg p-6 mb-6">
                <h4 className="text-[#1B3A5F] font-bold text-xl mb-4">Fisher Valve Models We Buy:</h4>
                <div className="grid md:grid-cols-2 gap-3">
                  {[
                    'Fisher EZ Valves Tulsa',
                    'Fisher ED Valves Tulsa',
                    'Fisher HP Valves Tulsa',
                    'Fisher DVC6000 Tulsa',
                    'Fisher DVC2000 Tulsa',
                    'Fisher 657 Actuators Tulsa',
                    'Fisher 667 Actuators Tulsa',
                    'Masoneilan Valves Tulsa'
                  ].map((model, index) => (
                    <div key={index} className="flex items-center">
                      <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                      <span className="text-gray-700">{model}</span>
                    </div>
                  ))}
                </div>
              </div>
              
              <div className="bg-gradient-to-r from-[#1B3A5F] to-[#2B5F8F] rounded-lg p-6 text-white">
                <h4 className="font-bold mb-3">Why Sell Fisher Valves to Us:</h4>
                <div className="grid md:grid-cols-2 gap-3">
                  <div className="flex items-center">
                    <i className="ri-money-dollar-circle-line mr-3"></i>
                    <span>Highest Fisher valve prices</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-time-line mr-3"></i>
                    <span>Same-day quotes</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-truck-line mr-3"></i>
                    <span>Free pickup Tulsa</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-file-list-line mr-3"></i>
                    <span>Complete documentation</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Rosemount Transmitters Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h3 className="text-[#1B3A5F] text-3xl font-bold mb-6">Rosemount Transmitter Buyers Tulsa Oklahoma - Rosemount 3051 2088 644 8800</h3>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                We are the premier <strong className="text-[#1B3A5F]">Rosemount transmitter buyers Tulsa Oklahoma</strong>. 
                We purchase all Rosemount instrumentation including <strong className="text-[#1B3A5F]">Rosemount 3051, 
                Rosemount 2088, Rosemount 644, Rosemount 8800, Rosemount 5400</strong>, and all Rosemount equipment 
                from Tulsa area refineries.
              </p>
              
              <div className="bg-[#F5F7FA] rounded-lg p-6 mb-6">
                <h4 className="text-[#1B3A5F] font-bold text-xl mb-4">Rosemount Models We Buy:</h4>
                <div className="grid md:grid-cols-2 gap-3">
                  {[
                    'Rosemount 3051 Tulsa',
                    'Rosemount 2088 Tulsa',
                    'Rosemount 644 Tulsa',
                    'Rosemount 8800 Tulsa',
                    'Rosemount 5400 Tulsa',
                    'Rosemount 1151 Tulsa',
                    'Rosemount 3144 Tulsa',
                    'Foxboro Transmitters Tulsa'
                  ].map((model, index) => (
                    <div key={index} className="flex items-center">
                      <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                      <span className="text-gray-700">{model}</span>
                    </div>
                  ))}
                </div>
              </div>
              
              <div className="bg-gradient-to-r from-[#1B3A5F] to-[#2B5F8F] rounded-lg p-6 text-white">
                <h4 className="font-bold mb-3">Rosemount Equipment Benefits:</h4>
                <div className="grid md:grid-cols-2 gap-3">
                  <div className="flex items-center">
                    <i className="ri-money-dollar-circle-line mr-3"></i>
                    <span>Top Rosemount prices</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-time-line mr-3"></i>
                    <span>Immediate cash offers</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-truck-line mr-3"></i>
                    <span>Professional logistics</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-shield-check-line mr-3"></i>
                    <span>Certified documentation</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div 
              className="rounded-3xl overflow-hidden shadow-lg bg-cover bg-center h-96"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Rosemount%20pressure%20transmitter%20model%203051%20professional%20industrial%20instrumentation%20equipment%20clean%20white%20background%20product%20photography&width=600&height=400&seq=rosemount-tulsa-035&orientation=landscape')`
              }}
            >
              <div className="bg-gradient-to-t from-[#1B3A5F]/80 to-transparent h-full flex items-end p-8">
                <div className="text-white">
                  <h3 className="text-2xl font-bold mb-2">Rosemount Transmitters Tulsa</h3>
                  <p>Rosemount 3051 2088 644 8800 - Best Prices</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Safety Relief Valves and Pipeline Valves Section */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">Safety Relief Valve Buyers Tulsa Oklahoma - Pipeline Valve Buyers</h2>
            <p className="text-gray-600 text-xl">We buy safety relief valves and pipeline valves from all Tulsa area refineries</p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-12">
            <div className="bg-white rounded-3xl p-8">
              <div className="w-16 h-16 bg-[#1B3A5F] rounded-lg flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-white text-3xl"></i>
              </div>
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-4">Safety Relief Valves Tulsa</h3>
              <p className="text-gray-600 mb-6">
                We buy all safety relief valves in Tulsa Oklahoma from Crosby, Anderson Greenwood, Consolidated, 
                Leser, Farris, and Dresser. Top dollar paid for pressure relief valves and overpressure protection equipment.
              </p>
              
              <div className="space-y-3 mb-6">
                <h4 className="font-bold text-gray-800">Brands We Buy:</h4>
                {[
                  'Crosby Safety Valves Tulsa',
                  'Anderson Greenwood Tulsa',
                  'Consolidated Valves Tulsa',
                  'Leser Safety Valves Tulsa',
                  'Farris Relief Valves Tulsa',
                  'Dresser Valves Tulsa'
                ].map((brand, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">{brand}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="bg-white rounded-3xl p-8">
              <div className="w-16 h-16 bg-[#1B3A5F] rounded-lg flex items-center justify-center mb-6">
                <i className="ri-road-map-line text-white text-3xl"></i>
              </div>
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-4">Pipeline Valves Tulsa</h3>
              <p className="text-gray-600 mb-6">
                We buy all pipeline valves in Tulsa Oklahoma including ball valves, gate valves, check valves, 
                and plug valves from Cameron, Velan, Powell, WKM, Grove, and all major manufacturers.
              </p>
              
              <div className="space-y-3 mb-6">
                <h4 className="font-bold text-gray-800">Valve Types We Buy:</h4>
                {[
                  'Cameron Ball Valves Tulsa',
                  'Velan Gate Valves Tulsa',
                  'WKM Valves Tulsa',
                  'Grove Ball Valves Tulsa',
                  'Powell Gate Valves Tulsa',
                  'Check Valves Tulsa'
                ].map((type, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">{type}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment We Buy */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">Sell Surplus Valves Tulsa Oklahoma - Contact Tulsa Oklahoma Valve Buyers</h2>
            <p className="text-gray-600 text-xl">Professional equipment buyers serving all Oklahoma refineries</p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-8">
            {[
              {
                category: 'Control Valves Tulsa',
                brands: ['Fisher', 'Masoneilan', 'Flowserve', 'Emerson'],
                types: ['Globe Control Valves', 'Ball Valves', 'Butterfly Valves', 'Angle Valves']
              },
              {
                category: 'Instrumentation Tulsa',
                brands: ['Rosemount', 'Foxboro', 'Honeywell', 'Yokogawa'],
                types: ['Pressure Transmitters', 'Flow Computers', 'Level Instruments', 'Temperature']
              },
              {
                category: 'Pipeline Equipment',
                brands: ['Cameron', 'FMC', 'Grove', 'Bonney Forge'],
                types: ['Gate Valves', 'Check Valves', 'Strainers', 'Flanges']
              }
            ].map((equipment, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-3xl p-8 hover:shadow-lg transition-all duration-300">
                <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">{equipment.category}</h3>
                
                <div className="mb-6">
                  <h4 className="text-gray-800 font-bold mb-3">Top Brands We Buy:</h4>
                  <div className="grid grid-cols-2 gap-2">
                    {equipment.brands.map((brand, brandIndex) => (
                      <div key={brandIndex} className="bg-[#1B3A5F]/10 text-[#1B3A5F] px-3 py-2 rounded-lg text-sm font-medium text-center">
                        {brand}
                      </div>
                    ))}
                  </div>
                </div>
                
                <div>
                  <h4 className="text-gray-800 font-bold mb-3">Equipment Types:</h4>
                  <div className="space-y-2">
                    {equipment.types.map((type, typeIndex) => (
                      <div key={typeIndex} className="flex items-center">
                        <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                        <span className="text-gray-600">{type}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* We Buy Surplus Valves Tulsa */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">WE BUY SURPLUS VALVES TULSA</h2>
            <p className="text-gray-600 text-xl">Tulsa's premier surplus valve buyers - serving the Oil Capital</p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h3 className="text-[#1B3A5F] text-3xl font-bold mb-6">TULSA SURPLUS VALVE SPECIALISTS</h3>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                As <strong className="text-[#1B3A5F]">Tulsa's leading surplus valve buyers</strong>, 
                we honor Oklahoma's oil heritage by providing fair market value for quality used valves 
                from refineries, pipeline terminals, and energy facilities throughout the Oil Capital region. 
                Our century of combined Oklahoma energy experience ensures expert equipment assessment.
              </p>
              
              <div className="space-y-4 mb-8">
                {[
                  {
                    type: 'Oil Capital Refinery Valves',
                    description: 'Fisher, Masoneilan from Phillips 66 Ponca City, HollyFrontier',
                    count: '600+ Units',
                    icon: 'ri-oil-line'
                  },
                  {
                    type: 'Pipeline Terminal Valves',
                    description: 'Gate valves, ball valves from Magellan Midstream terminals',
                    count: '400+ Units',
                    icon: 'ri-road-map-line'
                  },
                  {
                    type: 'Energy Company Valves',
                    description: 'Control valves from Oklahoma energy sector facilities',
                    count: '300+ Units',
                    icon: 'ri-lightning-line'
                  },
                  {
                    type: 'Historic Oil Industry Valves',
                    description: 'Vintage and specialty valves from Tulsa\'s oil industry heritage',
                    count: '150+ Units',
                    icon: 'ri-time-line'
                  }
                ].map((valve, index) => (
                  <div key={index} className="bg-[#F5F7FA] rounded-lg p-4">
                    <div className="flex items-start">
                      <div className="w-12 h-12 bg-[#1B3A5F] rounded-lg flex items-center justify-center mr-4">
                        <i className={`${valve.icon} text-white text-xl`}></i>
                      </div>
                      <div className="flex-1">
                        <div className="flex justify-between items-start mb-2">
                          <h4 className="text-[#1B3A5F] font-bold text-lg">{valve.type}</h4>
                          <span className="text-[#1B3A5F] text-sm font-semibold">{valve.count}</span>
                        </div>
                        <p className="text-gray-600 text-sm">{valve.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="bg-gradient-to-r from-[#1B3A5F] to-[#2B5F8F] rounded-lg p-6 text-white">
                <h4 className="font-bold mb-3">Oil Capital Heritage:</h4>
                <div className="grid md:grid-cols-2 gap-3">
                  <div className="flex items-center">
                    <i className="ri-time-line mr-3"></i>
                    <span>Same-day response</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-money-dollar-circle-line mr-3"></i>
                    <span>Highest Oklahoma prices</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-truck-line mr-3"></i>
                    <span>Oil Capital logistics</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-award-line mr-3"></i>
                    <span>Century oil experience</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div 
              className="rounded-3xl overflow-hidden shadow-lg bg-cover bg-center h-96"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Tulsa%20Oklahoma%20Oil%20Capital%20surplus%20valves%20Fisher%20control%20valves%20refinery%20equipment%20Phillips%2066%20HollyFrontier%20professional%20valve%20warehouse%20organized%20inventory%20oil%20derricks%20skyline&width=600&height=400&seq=tulsa-surplus-valves-015&orientation=landscape')`
              }}
            >
              <div className="bg-gradient-to-t from-[#1B3A5F]/80 to-transparent h-full flex items-end p-8">
                <div className="text-white">
                  <h3 className="text-2xl font-bold mb-2">Oil Capital Heritage Valves</h3>
                  <p>Premium surplus valves from Tulsa's legendary oil industry</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Service Areas */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Our Service Coverage in Tulsa
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We provide equipment pickup services throughout the greater Tulsa metropolitan area
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">North Tulsa</h3>
              <p className="text-gray-600">Turley, Sperry, Skiatook areas</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">South Tulsa</h3>
              <p className="text-gray-600">Bixby, Jenks, Glenpool areas</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">East Tulsa</h3>
              <p className="text-gray-600">Catoosa, Broken Arrow, Claremore areas</p>
            </div>
          </div>
        </div>
      </section>

      {/* Premium Equipment Brands Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Premium Equipment Brands We Buy in Tulsa
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We purchase top-quality industrial equipment from leading manufacturers throughout Tulsa, Oklahoma
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-red-50 to-orange-50 p-6 rounded-lg border border-red-100">
              <div className="w-12 h-12 bg-red-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-settings-3-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Control Valves Tulsa</h3>
              <p className="text-gray-600 mb-4">
                Fisher Control Valves Tulsa, Masoneilan Tulsa, Q-Check Tulsa, Valtek Tulsa, Centerline Tulsa
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-red-100 text-red-800 text-sm rounded">Fisher Tulsa</span>
                <span className="px-2 py-1 bg-red-100 text-red-800 text-sm rounded">Masoneilan Tulsa</span>
                <span className="px-2 py-1 bg-red-100 text-red-800 text-sm rounded">Q-Check Tulsa</span>
              </div>
              <a href="/contact" className="text-red-600 hover:text-red-700 font-medium">Get Tulsa Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-lg border border-green-100">
              <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-dashboard-3-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Instrumentation Tulsa</h3>
              <p className="text-gray-600 mb-4">
                Rosemount Transmitters Tulsa, Foxboro Tulsa, Fisher Instruments Tulsa, Barton Tulsa equipment
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-green-100 text-green-800 text-sm rounded">Rosemount Tulsa</span>
                <span className="px-2 py-1 bg-green-100 text-green-800 text-sm rounded">Foxboro Tulsa</span>
                <span className="px-2 py-1 bg-green-100 text-green-800 text-sm rounded">Fisher Tulsa</span>
              </div>
              <a href="/contact" className="text-green-600 hover:text-green-700 font-medium">Get Tulsa Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-6 rounded-lg border border-blue-100">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-water-percent-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Water Systems Tulsa</h3>
              <p className="text-gray-600 mb-4">
                Badger Water Meters Tulsa, Neptune Tulsa, Rockwell Tulsa, flow measurement equipment
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded">Badger Tulsa</span>
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded">Neptune Tulsa</span>
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded">Rockwell Tulsa</span>
              </div>
              <a href="/contact" className="text-blue-600 hover:text-blue-700 font-medium">Get Tulsa Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-indigo-50 p-6 rounded-lg border border-purple-100">
              <div className="w-12 h-12 bg-purple-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-cpu-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Actuators Tulsa</h3>
              <p className="text-gray-600 mb-4">
                Limitorque Tulsa, Bettis Actuators Tulsa, Fisher Actuators Tulsa, Q-Check Actuators Tulsa
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-sm rounded">Limitorque Tulsa</span>
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-sm rounded">Bettis Tulsa</span>
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-sm rounded">Fisher Tulsa</span>
              </div>
              <a href="/contact" className="text-purple-600 hover:text-purple-700 font-medium">Get Tulsa Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-cyan-50 p-6 rounded-lg border border-teal-100">
              <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-plug-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Fittings Tulsa</h3>
              <p className="text-gray-600 mb-4">
                Swagelok Tulsa, Parker Fittings Tulsa, Anderson Greenwood Tulsa, Hoke Tulsa manifolds
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-teal-100 text-teal-800 text-sm rounded">Swagelok Tulsa</span>
                <span className="px-2 py-1 bg-teal-100 text-teal-800 text-sm rounded">Parker Tulsa</span>
                <span className="px-2 py-1 bg-teal-100 text-teal-800 text-sm rounded">Anderson Tulsa</span>
              </div>
              <a href="/contact" className="text-teal-600 hover:text-teal-700 font-medium">Get Tulsa Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-yellow-50 p-6 rounded-lg border border-amber-100">
              <div className="w-12 h-12 bg-amber-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-temp-hot-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Gauges Tulsa</h3>
              <p className="text-gray-600 mb-4">
                WIKA Gauges Tulsa, All Temp Sensors Tulsa, OCI Tulsa, McDaniel Tulsa thermowells
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-amber-100 text-amber-800 text-sm rounded">WIKA Tulsa</span>
                <span className="px-2 py-1 bg-amber-100 text-amber-800 text-sm rounded">All Temp Tulsa</span>
                <span className="px-2 py-1 bg-amber-100 text-amber-800 text-sm rounded">OCI Tulsa</span>
              </div>
              <a href="/contact" className="text-amber-600 hover:text-amber-700 font-medium">Get Tulsa Quote →</a>
            </div>
          </div>

          <div className="mt-12 text-center">
            <div className="bg-gray-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Ready to Sell Your Equipment in Tulsa?</h3>
              <p className="text-lg text-gray-600 mb-6">
                Contact us today for a free quote on your surplus industrial equipment in Tulsa, Oklahoma
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="tel:2148545638" className="bg-red-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-red-700 transition duration-300">
                  Call (214) 854-5638
                </a>
                <a href="/contact" className="bg-gray-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-700 transition duration-300">
                  Get Free Quote
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">TULSA VALVE BUYERS - FREQUENTLY ASKED QUESTIONS</h2>
            <p className="text-gray-600 text-xl">Common questions about selling equipment to Tulsa Oklahoma buyers</p>
          </div>
          
          <div className="space-y-8">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-2xl p-8">
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-4">{faq.question}</h3>
                <p className="text-gray-700 text-lg leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Tulsa Contact Section */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-white text-4xl font-bold mb-4">CONTACT TULSA VALVE BUYERS</h2>
            <p className="text-gray-200 text-xl">Fast response for all Oklahoma refineries</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">TULSA REGIONAL OFFICE</h3>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <i className="ri-phone-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold text-lg">214-854-5638</div>
                    <div className="text-gray-600">Direct Tulsa Response Line</div>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-mail-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold">tulsa@valvesalessupply.com</div>
                    <div className="text-gray-600">Oklahoma Equipment Lists</div>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <i className="ri-time-line text-[#1B3A5F] text-xl mr-4 mt-1"></i>
                  <div>
                    <div className="font-bold">Same Day Response</div>
                    <div className="text-gray-600">Fastest in Oklahoma</div>
                  </div>
                </div>
              </div>
              
              <div className="bg-[#F5F7FA] rounded-lg p-4">
                <h4 className="text-[#1B3A5F] font-bold mb-2">Oklahoma Regional Manager</h4>
                <p className="text-gray-600">Mark Driver - Oklahoma oil & gas veteran</p>
              </div>
            </div>
            
            <div className="text-white">
              <h3 className="text-3xl font-bold mb-6">WHY OKLAHOMA REFINERIES TRUST US</h3>
              <div className="space-y-4">
                {[
                  'Highest surplus valve prices in Oklahoma',
                  'Same-day site visits and quotes',
                  'Expert Oklahoma refinery knowledge',
                  'Complete compliance documentation',
                  'Local Tulsa team with pipeline experience',
                  '24/7 emergency turnaround support'
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-white text-xl mr-4"></i>
                    <span className="text-lg">{benefit}</span>
                  </div>
                ))}
              </div>
              
              <div className="mt-8">
                <a
                  href="tel:214-854-5638"
                  className="bg-white text-[#1B3A5F] px-10 py-4 rounded-full text-xl font-semibold hover:bg-gray-100 transition-all duration-300 inline-flex items-center whitespace-nowrap"
                >
                  CALL TULSA: 214-854-5638
                  <i className="ri-phone-line ml-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Tulsa;
